<script>

import { mapGetters } from "vuex";

export default {

    computed:{
        user() {
            return this.$store.state.user.user
        },
        status_info(){
            if (this.user.role.is_student){
                if(this.GET_STATUS_INFO){
                    let code = this.GET_STATUS_INFO.code
                    return code == 'CONFIRMED'||code == 'CHOSEN'
                }else{
                    return false
                }
            }else{
                if(this.GET_STATUS_INFO){
                    let code = this.GET_STATUS_INFO.code
                    return code == 'CONFIRMED'
                }else{
                    return false
                }
            }
        },
        DisabledLang(){
            if(this.discipline.status.utverzhden ==true ||  this.discipline.is_active == false || this.status_info){
                return true
            }
            return false;
        },
        ...mapGetters({
            GET_STATUS_INFO: 'regis_discepline/GET_STATUS_INFO',
        }),
    },
    methods: {
        DisabledTeacher(index){
            if(this.discipline.status.utverzhden ==true ||  this.discipline.is_active == false || !this.select['lang'][index]){
                return true
            }
            return false;
        },

        async auto_srs_lang(uid_1c,i){
            if (uid_1c == 'СРСП'){
                this.discipline.type_load.forEach((item,index)=>{
                    if (item.uid_1c=='СРС'){
                        this.select.lang[index] = this.select.lang[i]
                    }
                })
            }
        },
        async auto_srs_teach(uid_1c,i){
            if (uid_1c == 'СРСП'){
                this.discipline.type_load.forEach((item,index)=>{
                    if (item.uid_1c=='СРС'){
                        this.select.teacher[index] = this.select['teacher'][i]
                    }
                })
            }
        },
        async selectLanguage(type_id,index,group_language,status,uid_1c){
            this.useFilter();

            this.$vs.loading();
            this.language_options = [];
            try {

                await this.$http.get("user/languages_teacher_discipline/", {
                    params: {
                        discipline: this.discipline.discipline.uid,
                        study_period:this.$route.query.study_year,
                        load_type: type_id,
                    },
                }).then(async (res)=>{
                    this.language_options = res.data;
                    if(res.data.length == 1){ // if alone language select this
                        this.select.lang[index] = await res.data[0];
                        await this.selectTeacher(type_id,index);
                        await this.auto_srs_lang(uid_1c,index)
                        await this.auto_srs_teach(uid_1c,index)
                    }else{
                        if (status.nevybran||status.otklonen||status.neizuchaetsja){
                            res.data.forEach( (type, i) => {
                                if (type.language==group_language.language_uid){
                                    this.select.lang[index] =  type;
                                    this.selectTeacher(type_id,index,uid_1c);
                                    this.auto_srs_lang(uid_1c,index)
                                }
                            })
                        }
                    }

                })


            } catch (e) {
                this.$vs.notify({  title: this.$t("error"), color: "danger", });
            }finally{
                this.$vs.loading.close();
                // console.log('selectLanguage finally is_state',this.is_state)
            }
        },

        async selectTeacher(type_id,index,uid_1c){
            this.useFilter();

            // this.$vs.loading();

            this.teacher_options = [];
            try {

                await this.$http.get("user/languages_teacher_discipline/", {
                    params: {
                        discipline: this.discipline.discipline.uid,
                        study_period:this.$route.query.study_year,
                        load_type: type_id,
                        language:this.select['lang'][index]['uid']
                    },
                }).then((res)=>{
                    this.teacher_options = res.data;
                    // console.log(res.data.length)
                    if(res.data.length == 1){ // if alone language select this
                        this.select.teacher[index] = res.data[0];
                    }
                    this.auto_srs_teach(uid_1c,index)

                })

            } catch (e) {
                this.$vs.notify({  title: this.$t("error"), color: "danger", });
            }finally{
                // this.$vs.loading.close();
            }
        },
        async selectTeacherNew(type_id,index){
            this.useFilter();

            this.loading_teacher = true;

            this.teacher_options = [];
            try {

                const response = (
                    await this.$http.get("user/languages_teacher_discipline/", {
                        params: {
                            discipline: this.discipline.discipline.uid,
                            study_period:this.$route.query.study_year,
                            load_type: type_id,
                            language:this.select['lang'][index]['uid']
                        },
                    })
                ).data;
                this.teacher_options = response

            } catch (e) {
                this.$vs.notify({  title: this.$t("error"), color: "danger", });
            }finally{
                this.loading_teacher = false;
            }
        },
        async selectLanguageNew(type_id){
            this.useFilter();

            this.loading_language = true;
            this.language_options = [];
            try {

                const response = (
                    await this.$http.get("user/languages_teacher_discipline/", {
                        params: {
                            discipline: this.discipline.discipline.uid,
                            study_period:this.$route.query.study_year,
                            load_type: type_id,
                        },
                    })
                ).data;
                this.language_options = response

            } catch (e) {
                this.$vs.notify({  title: this.$t("error"), color: "danger", });
            }finally{
                this.loading_language = false;
                // console.log('selectLanguage finally is_state',this.is_state)
            }
        },



        useFilter() {
            // параметр из роута
            // проверка на study_year нужен для того что бы плобзователь не удалил его и для успешного request
            // все request работают только с выбранном study_year
            const obj = this.$route.query;
            if (
                "study_year" in obj
            ) {
                return true
            } else {
                if (this.user.role.is_student){
                    this.$vs.notify({ title: this.$t("error"),text: this.$t("Fillallfields"),color: "warning",});
                }
            }
        },
    },
}
</script>
